module.exports = __webpack_public_path__ + "2d1991a5c5926ebf70d7730a3181aefd.svg";